import type { ApolloError } from '@apollo/client';

/** The API answers 403 when the auth token is valid but no active user in our DB matches it. */
export const isForbiddenError = (error?: ApolloError): boolean =>
  !!error?.networkError &&
  'statusCode' in error.networkError &&
  error.networkError.statusCode === 403;
